module.exports = __webpack_public_path__ + "static/img/apple.f802b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/component/footer/apple.png
// module id = eOHG
// module chunks = 30